import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import UserReflectionRoutes from '../../user-reflection/routes'

const UsersRoutes = () => {
    return (
        <React.Fragment>
            <UserReflectionRoutes />
        </React.Fragment>
    )
}

export default UsersRoutes